import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { IonCard } from '@ionic/react';
import { usePortalPickerRect } from './usePortalPickerRect';

export function PortalPickerDropdown({
  isOpen,
  fieldRef,
  portalRef,
  close,
  align,
  className,
  children,
  matchWidth,
  exactWidth,
}: {
  isOpen: boolean;
  fieldRef: React.RefObject<HTMLElement | null>;
  portalRef: React.RefObject<HTMLElement | null>;
  close: () => void;
  align: 'left' | 'right';
  className: string;
  matchWidth?: boolean;
  exactWidth?: boolean;
  children: React.ReactNode;
}) {
  const cardRef = useRef<HTMLIonCardElement>(null);
  const rect = usePortalPickerRect(isOpen, fieldRef, portalRef, cardRef, close, align, matchWidth, exactWidth);

  // portalRef's target renders alongside this component (see e.g. Contact.tsx's
  // fixed inset:0 container), so its .current is only reliably non-null after
  // this component itself has committed at least once — track that in state
  // instead of reading .current directly during render.
  const [portalNode, setPortalNode] = useState<HTMLElement | null>(null);
  useEffect(() => {
    setPortalNode(portalRef.current);
  }, [portalRef, isOpen]);

  if (!isOpen || !rect || !portalNode) return null;

  return createPortal(
    <IonCard ref={cardRef} className={className} style={{ ...rect, position: 'absolute' }}>
      {children}
    </IonCard>,
    portalNode,
  );
}
